export function NewCountryTypeCtrl ($scope, $uibModalInstance, $translate, workshopAPI, messages) {

	$scope.country = {
		country_code : '',
		code: '',
		description: '',
		country_phone_code: '',
		business_id_name: '',
		plate_number_name: '',
		country_code_2: '',
		invoice_name: '',
		business_id_short: ''
	}

	$scope.cancel = function () {
		$uibModalInstance.dismiss();
	};

	$scope.save = function (form) {
		workshopAPI.post('/country_types', $scope.country, 'country_type')
			.then(function (type) {
				messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.COUNTRY_ADDED'), 'success');
				$uibModalInstance.close(type);
			}, function (err) {
				messages.error(err, form);
			});
	};

}